import { treatsItem } from '@/business/apiTreatment/response/baseAPITreatment';
import BaseService from '@/services/services/tools/baseService';
import dashboardDispatcherAPI from '../api/internal/dashboardDispatcherApi';

const dispatchFieldNames = [
  'last_hour',
  'cumul',
  'deadline_expired',
  'waiting_tech_affectation',
  'waiting',
  'not_transmitted',
  'not_received',
  'waiting_acknowledge',
];

const dashboardDispatcherService = new BaseService({
  api: dashboardDispatcherAPI,
  treatCurrentResponse: treatsItem({ dispatchFieldNames }),
});

export default dashboardDispatcherService;
